import { render } from "./WarehouseInvoices.vue?vue&type=template&id=2d83ebc5&scoped=true"
import script from "./WarehouseInvoices.vue?vue&type=script&lang=js"
export * from "./WarehouseInvoices.vue?vue&type=script&lang=js"

import "./WarehouseInvoices.vue?vue&type=style&index=0&id=2d83ebc5&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d83ebc5"]])

export default __exports__